import React, { useState, useEffect, useContext, useRef } from 'react';
import CustomTabs from '../../components/CustomComponents/CustomTabs/CustomTabs';
import CustomTab from '../../components/CustomComponents/CustomTab/CustomTab';
import CustomBox from '../../components/CustomComponents/CustomBox/CustomBox';
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from '../../components/CustomComponents/CustomGrid/CustomGrid';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useStyles } from '../../assets/jss/ReportedEvents';
import backButton from "../../assets/images/back_button.svg";
import { useParams, useHistory } from 'react-router-dom';
import { EventTypes, ReportedEventStatus, TableComponentCodes } from "../../config/app-globals.enum";
import { getReportList } from '../../services/PraisoTableService';
import CustomCircularProgress from '../../components/CustomComponents/CustomCircularProgress/CustomCircularProgress';
import CustomPaper from '../../components/CustomComponents/CustomPaper/CustomPaper';
import ErrorAlert from '../../components/ErrorAlert/ErrorAlert';
import { getIsCameFromEventDetailsPage, getTabIdForRE, setReportedEventDropDownIndex, getReportedEventDropDownIndex, setIsCameFromEventDetailsPage, setTabIdForRE } from '../../services/LocalStorageService';
import UserContext, { UserProvider } from '../../context/UserContext';

const ReportedEvents = () => {

    const [value, setValue] = React.useState(getTabIdForRE() !== null && getIsCameFromEventDetailsPage() ? getTabIdForRE() : 0);
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const [reportData, setreportData] = useState([]);
    const [activeReport, setActiveReport] = useState([]);
    const [rejectReport, setRejectReport] = useState([]);
    const [reportCount, setreportcount] = useState(0);
    const [activeReportCount, setActiveReportCount] = useState(0);
    const [rejectReportCount, setRejectReportCount] = useState(0);
    const [isApi, setIsApi] = useState(false);
    const { eventCategory } = useContext(UserContext);
    const [eventCategoryChild, setEventCategoryChild] = useState(
        (getReportedEventDropDownIndex() !== undefined && getReportedEventDropDownIndex() !== null && getIsCameFromEventDetailsPage()) ?
            getReportedEventDropDownIndex() :
            eventCategory
    );
    // const [eventCategoryChild, setEventCategoryChild] = useState(eventCategory);

    const handleTabs = (event, newValue) => {
        setValue(newValue);
        setTabIdForRE(newValue);
    };

    //====
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);

    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };
    async function getReportData() {
        setStatusValue(null);
        setAlertMessage("");
        setIsAlertOpen(false);
        setIsApi(true);
        const reportEvent = value + 1;
        const data = await getReportList(reportEvent, eventCategoryChild + "");
        if (
            data &&
            (data.status.code === 0 ||
                data.status.code === 200 ||
                data.status.code === 201) &&
            data.content
        ) {
            const datav = [];
            // let eventList = [];
            setreportcount(data.content.activeEventCount);
            setActiveReportCount(data.content.approvedEventCount);
            setRejectReportCount(data.content.rejectedEventCount);

            //Make flat object
            data.content.reportedEventList.forEach((eventDetail) => {
                Object.keys(eventDetail).forEach(key => {
                    if (typeof eventDetail[key] == 'object') {
                        eventDetail[key].forEach((d) => {
                            d.name = eventDetail.name;
                            d.eventCount = eventDetail.eventCount;
                            d.userId = eventDetail.userId;
                            datav.push(d);
                        })
                    }
                })
            })
            // Sorting Desending based on occurredAt 
            if (datav && datav.length > 0) {
                datav.sort((a, b) => (new Date(a.occurredAt) < new Date(b.occurredAt)) ? 1 : -1)
            }

            if (reportEvent === ReportedEventStatus.REPORTED) {
                setreportData(datav);
            } else if (reportEvent === ReportedEventStatus.APPROVED) {
                setActiveReport(datav);
            } else {
                setRejectReport(datav);
            }
            setIsApi(false);
            changeApiStatusCodeFunc(data.status);
        } else {
            changeApiStatusCodeFunc(data.status);
        }
    }
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null) {
            if (getIsCameFromEventDetailsPage() === 0) {
                setReportedEventDropDownIndex(EventTypes.SPEEDING);
                setValue(0);
            } else {
                if (getReportedEventDropDownIndex() !== undefined && getReportedEventDropDownIndex() !== null && getReportedEventDropDownIndex() !== -1) {
                    setEventCategoryChild(getReportedEventDropDownIndex());
                    if (getTabIdForRE()) {
                        setValue(getTabIdForRE());
                    } else {
                        setValue(0);
                    }

                }
            }
        }
        return () => {
            mounted.current = false;
            setIsCameFromEventDetailsPage(0);
        };
    }, []);

    useEffect(() => {
        if (reportData.length === 0 || activeReport.length === 0 || rejectReport.length === 0 || value !== 0) {
            getReportData();
        }
    }, [eventCategoryChild, value]);

    useEffect(() => {
        setReportedEventDropDownIndex(eventCategoryChild);
    }, [eventCategoryChild]);



    useEffect(() => {
        if (value === null) {
            setValue(0);
            setTabIdForRE(0);
        }
    }, []);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
        className: PropTypes.any,
    };
    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <CustomBox m={3}>{children}</CustomBox>}
            </div>
        );
    }

    const goBackFunc = () => {
        (params.impersonationid && history.length > 1) || !params.impersonationid ? history.push('/admin/') : history.push(`/dashboard/impersonation/${params.impersonationid}`);
    }

    function getTableView(eventCategoryChild: number) {
        var event = "";
        if (value === 0) {
            if (eventCategoryChild === EventTypes.SPEEDING) {
                event = TableComponentCodes.REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.BRAKING) {
                event = TableComponentCodes.BRAKING_REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.CORNERING) {
                event = TableComponentCodes.CORNERING_REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.ACCELERATION) {
                event = TableComponentCodes.ACCELERATION_REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.DISTRACTION) {
                event = TableComponentCodes.DISTRACTION_REPORTED_EVENTS;
            }
        } else if (value === 1) {
            if (eventCategoryChild === EventTypes.SPEEDING) {
                event = TableComponentCodes.APPROVED_REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.BRAKING) {
                event = TableComponentCodes.BRAKING_APPROVED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.CORNERING) {
                event = TableComponentCodes.CORNERING_APPROVED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.ACCELERATION) {
                event = TableComponentCodes.ACCELERATION_APPROVED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.DISTRACTION) {
                event = TableComponentCodes.DISTRACTION_APPROVED_EVENTS;
            }
        } else {
            if (eventCategoryChild === EventTypes.SPEEDING) {
                event = TableComponentCodes.REJECTED_REPORTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.BRAKING) {
                event = TableComponentCodes.BRAKING_REJECTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.CORNERING) {
                event = TableComponentCodes.CORNERING_REJECTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.ACCELERATION) {
                event = TableComponentCodes.ACCELERATION_REJECTED_EVENTS;
            }
            else if (eventCategoryChild === EventTypes.DISTRACTION) {
                event = TableComponentCodes.DISTRACTION_REJECTED_EVENTS;
            }
        }
        return event;
    }

    return (
        <>
            <CustomGrid container spacing={4} justifyContent="space-between">
                <CustomGrid item xs={12}>
                    <Breadcrumb
                        currentPage={t("REPORTED_EVENTS")}
                        showAdmin
                    />
                </CustomGrid>
            </CustomGrid>
            <CustomBox item>
                <CustomTypography
                    component="h1"
                    variant="h5"
                    className={classes.headerTitle}
                >
                    <img
                        src={backButton}
                        onClick={goBackFunc}
                        style={{ marginRight: "20px", cursor: "pointer" }}
                        alt="Back"
                    />
                    {t("REPORTED_EVENTS")}
                </CustomTypography>
            </CustomBox>
            <CustomTabs
                className={classes.tabs}
                value={value}
                onChange={handleTabs}
                style={{ marginTop: '20px' }}
                indicatorColor="primary"
            >
                <CustomTab label={i18n.t("ACTIVE_COUNT", { count: reportCount })} {...a11yProps(0)} />
                <CustomTab label={i18n.t("APPROVED_COUNT", { count: activeReportCount })} {...a11yProps(1)} />
                <CustomTab label={i18n.t("REJECTED_COUNT", { count: rejectReportCount })} {...a11yProps(2)} />
            </CustomTabs>

            <TabPanel
                value={value}
                index={0}
                className={classes.tabPanel}
            >
                {isApi ? <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                >
                    <CustomCircularProgress />
                </CustomPaper> :
                    <UserProvider value={{ eventCategory: eventCategoryChild, setEventCategory: setEventCategoryChild }}>
                        <PraisoTableWrapper
                            tableSettingView={String(getTableView(eventCategoryChild))}
                            getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${String(getTableView(eventCategoryChild))}`}
                            preFetchedTableData={reportData}
                            callBackFun={getReportData}
                            isShowGlobalDropDown={true}
                        // eventCategory={eventCategory}
                        // setEventCategory={setEventCategory}
                        />
                    </UserProvider>
                }
            </TabPanel>
            <TabPanel
                value={value}
                index={1}
                className={classes.tabPanel}
            >
                {isApi ? <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                >
                    <CustomCircularProgress />
                </CustomPaper> : <PraisoTableWrapper
                    tableSettingView={String(getTableView(eventCategoryChild))}
                    getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${String(getTableView(eventCategoryChild))}`}
                    preFetchedTableData={activeReport}
                    callBackFun={getReportData}
                />}
            </TabPanel>
            <TabPanel
                value={value}
                index={2}
                className={classes.tabPanel}
            >
                {isApi ? <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                >
                    <CustomCircularProgress />
                </CustomPaper> : <PraisoTableWrapper
                    tableSettingView={String(getTableView(eventCategoryChild))}
                    getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${String(getTableView(eventCategoryChild))}`}
                    preFetchedTableData={rejectReport}
                    callBackFun={getReportData}
                />}
            </TabPanel>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    )
}

export default ReportedEvents
